import axios_nomura from './axios-nomura.services';

export const fetchAdvanceSearchFilters = async () => {
  return await axios_nomura.get(`api/v1/search/filters`);
};

export const fetchNavForAdvanceSearch = async (data) => {
  let convertDataToJson = JSON.stringify(data);
  return await axios_nomura.post(`api/v1/nav/ByFundIdAndType`, convertDataToJson);
};